/**
 * Pure, stateless path/edge helpers for the knowledge graph.
 * Extracted verbatim from knowledgeGraph.ts (these close over NO module state,
 * unlike the store-reading helpers which stay put). Imported back by the graph.
 */
import type { ApiSide } from './types';

export function edgeKey(kind: string, source: string, target: string): string {
  return `${kind}|${source}|${target}`;
}

export function looksLikeTestPath(path: string): boolean {
  return /(?:\b__tests__\b|\.spec\.ts$|\.test\.ts$)/.test(path);
}

export function pathSide(path: string): ApiSide {
  if (path.startsWith('client/') || path.includes('/client/')) return 'client';
  if (path.startsWith('server/') || path.includes('/server/')) return 'server';
  return 'shared';
}
